// ✅ Final Updated PhotographerList.jsx
import React, { useEffect, useState } from 'react';
import { Input, Button, Table, message, Popconfirm, Tag } from 'antd';
import { DeleteOutlined, CheckCircleOutlined } from '@ant-design/icons';

const PhotographerList = () => {
  const [photographers, setPhotographers] = useState([]);
  const [form, setForm] = useState({ name: '', email: '', tel: '', password: '' });

  const fetchPhotographers = async () => {
    const res = await fetch('http://localhost:5000/admin/photographers');
    const data = await res.json();
    setPhotographers(data);
  };

  useEffect(() => {
    fetchPhotographers();
  }, []);

  const handleAdd = async () => {
    if (!form.name || !form.email || !form.tel || !form.password) {
      message.warning("Please fill all fields");
      return;
    }

    try {
      const res = await fetch('http://localhost:5000/admin/add-photographer', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });

      const result = await res.json();
      if (res.ok) {
        message.success(result.message);
        setForm({ name: '', email: '', tel: '', password: '' });
        fetchPhotographers();
      } else {
        message.error(result.message || "Failed to add photographer");
      }
    } catch (err) {
      console.error(err);
      message.error("Something went wrong");
    }
  };

  const handleDelete = async (id) => {
    try {
      const res = await fetch(`http://localhost:5000/admin/delete-photographer/${id}`, {
        method: 'DELETE',
      });

      const result = await res.json();
      if (res.ok) {
        message.success(result.message);
        fetchPhotographers();
      } else {
        message.error(result.message || "Failed to delete");
      }
    } catch (err) {
      console.error(err);
      message.error("Something went wrong");
    }
  };

 const handleVerify = async (id) => {
  try {
    const res = await fetch(`http://localhost:5000/admin/verify-photographer/${id}`, {
      method: 'PUT',
    });

    const result = await res.json();

    if (res.ok) {
      message.success(result.message);
      fetchPhotographers(); // Refresh list
    } else {
      message.error(result.message || "Verification failed");
    }
  } catch (err) {
    console.error("❌ handleVerify Error:", err);
    message.error("Something went wrong");
  }
};

  return (
    <div>
      <h2>Add Photographer</h2>
      <Input
        name="name"
        autoComplete="off"
        placeholder="Name"
        value={form.name}
        onChange={(e) => setForm({ ...form, name: e.target.value })}
      />
      <Input
        name="email"
        autoComplete="off"
        placeholder="Email"
        value={form.email}
        onChange={(e) => setForm({ ...form, email: e.target.value })}
      />
      <Input
        name="tel"
        type="tel"
        autoComplete="off"
        placeholder="Phone"
        value={form.tel}
        onChange={(e) => setForm({ ...form, tel: e.target.value })}
      />
      <Input.Password
        name="password"
        autoComplete="new-password"
        placeholder="Password"
        value={form.password}
        onChange={(e) => setForm({ ...form, password: e.target.value })}
      />
      <Button type="primary" onClick={handleAdd} className="mt-2">Add Photographer</Button>

      <h3 className="mt-4">Existing Photographers</h3>
      <Table
        dataSource={photographers}
        columns={[
          { title: 'Name', dataIndex: 'name' },
          { title: 'Email', dataIndex: 'email' },
          { title: 'Phone', dataIndex: 'tel' },
          {
            title: 'Status',
            dataIndex: 'isVerified',
            render: (val) => val ? <Tag color="green">Verified</Tag> : <Tag color="red">Not Verified</Tag>
          },
          {
            title: 'Actions',
            render: (_, record) => (
              <>
                {!record.isVerified && (
                  <Button
                    type="primary"
                    icon={<CheckCircleOutlined />}
                    onClick={() => handleVerify(record._id)}
                    style={{ marginRight: 8 }}
                  >
                    Verify
                  </Button>
                )}
                <Popconfirm
                  title="Are you sure to delete this photographer?"
                  onConfirm={() => handleDelete(record._id)}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button type="primary" danger icon={<DeleteOutlined />} />
                </Popconfirm>
              </>
            )
          }
        ]}
        rowKey="_id"
      />
    </div>
  );
};

export default PhotographerList;